module.exports = __webpack_public_path__ + "img/title_bg.89d62e50.png";